import { DEFAULT_INFERENCE_FORM } from "../../../../features/forge/constants";
import { InferenceParameters } from "../../../../types";
import { DimensionsType } from "../../constants";
import { STYLE_FIELD_NAME } from "../../fields/StyleSelection/constants";
import { FormWithStyle } from "../../fields/StyleSelection/types";
import {
  DEFAULT_FIELDS_STYLE,
  formatFormWithStyleValuesForAPI,
  formatInferenceParamsForFormWithStyle,
} from "../../fields/StyleSelection/utils";
import { getPercentageFromWeight } from "../../utils/utils";
import { getWeightFromPercentage } from "../../utils/utils";

export const DEFAULT_CREATIVITY_REALTIME = 30;
export const MIN_CREATIVITY_REALTIME = 0;
export const MAX_CREATIVITY_REALTIME = 100;

export const REALTIME_FORM_FIELDS = {
  STYLE: STYLE_FIELD_NAME,
  PROMPT_LANGUAGE: "promptLanguage",
  PROMPT_TEXT: "promptText",
  CREATIVITY: "creativity",
  CANVAS_IMAGE: "canvasImage",
  DIMENSIONS: "dimensions",
} as const;

export const DEFAULT_REALTIME_FORM_VALUES: FormTypeRealtime = {
  ...DEFAULT_FIELDS_STYLE,
  [REALTIME_FORM_FIELDS.PROMPT_LANGUAGE]: null,
  [REALTIME_FORM_FIELDS.PROMPT_TEXT]: "",
  [REALTIME_FORM_FIELDS.CREATIVITY]: DEFAULT_CREATIVITY_REALTIME,
  [REALTIME_FORM_FIELDS.CANVAS_IMAGE]: null,
  [REALTIME_FORM_FIELDS.DIMENSIONS]: [1024, 1024],
};

export interface FormTypeRealtime extends FormWithStyle {
  [REALTIME_FORM_FIELDS.PROMPT_LANGUAGE]?: string;
  [REALTIME_FORM_FIELDS.PROMPT_TEXT]?: string;
  [REALTIME_FORM_FIELDS.CREATIVITY]: number;
  [REALTIME_FORM_FIELDS.CANVAS_IMAGE]?: string;
  [REALTIME_FORM_FIELDS.DIMENSIONS]: DimensionsType;
}

export const getDefaultRealtimeCanvasFormValues = () =>
  JSON.parse(JSON.stringify(DEFAULT_REALTIME_FORM_VALUES));
export const formatInferenceParamsForFormTypeRealtime = (
  params: InferenceParameters,
): Partial<FormTypeRealtime> => {
  const outputForm: Partial<FormTypeRealtime> = {
    ...formatInferenceParamsForFormWithStyle(params),
  };

  if (params) {
    if (params.width && params.height) {
      outputForm[REALTIME_FORM_FIELDS.DIMENSIONS] = [
        params.width,
        params.height,
      ];
    }
    if (typeof params.prompt !== "undefined") {
      outputForm[REALTIME_FORM_FIELDS.PROMPT_TEXT] = params.prompt;
    }
    if (typeof params.promptLanguage !== "undefined") {
      outputForm[REALTIME_FORM_FIELDS.PROMPT_LANGUAGE] = params.promptLanguage;
    }
    if (typeof params.creativity !== "undefined") {
      outputForm[REALTIME_FORM_FIELDS.CREATIVITY] = getPercentageFromWeight(
        params.creativity,
      );
    }
  }
  return outputForm;
};

export const formatRealtimeFormValuesForAPI = (
  inputForm: FormTypeRealtime,
): InferenceParameters => {
  const parameters: InferenceParameters = {
    ...DEFAULT_INFERENCE_FORM.parameters,
    ...formatFormWithStyleValuesForAPI(inputForm),
    generationType: "REALTIME",
    batchSize: 1,
    prompt: inputForm[REALTIME_FORM_FIELDS.PROMPT_TEXT],
    promptLanguage: inputForm[REALTIME_FORM_FIELDS.PROMPT_LANGUAGE],
    creativity: getWeightFromPercentage(
      inputForm[REALTIME_FORM_FIELDS.CREATIVITY],
    ),
    width: inputForm[REALTIME_FORM_FIELDS.DIMENSIONS][0],
    height: inputForm[REALTIME_FORM_FIELDS.DIMENSIONS][1],
  };
  return parameters;
};
